/*
    🔥 STORAGE SESSION HELPER
        Helper central para almacenamiento general y persistencia de sesión.
        La decisión entre localStorage y sessionStorage para autenticación se
        resuelve desde APP_ENVIRONMENT.AUTH.PERSIST_SESSION.

    ----------------------------------------------------------------------------
    🔥 PERSISTENCIA DE AUTH
        APP_CONFIG_GLOBAL.AUTH.PERSIST_SESSION=true
            El token de autenticación se guarda en localStorage y sobrevive al
            cierre/reapertura del navegador.

        APP_CONFIG_GLOBAL.AUTH.PERSIST_SESSION=false
            El token se guarda en sessionStorage y finaliza con la sesión del
            navegador.

        🎯 GET_AUTH_STORAGE migra automáticamente tokens encontrados en el
            almacenamiento opuesto para conservar compatibilidad con sesiones
            creadas antes de cambiar la configuración.

    ----------------------------------------------------------------------------
    🔥 LIMPIEZA
        CLEAR_AUTH()
            Elimina tokens y datos temporales de autenticación de ambos storages
            para garantizar un cierre de sesión completo.
*/

import { APP_ENVIRONMENT } from "../../_CORE/_RuntimeConfig/_Config/Acomodar/AppEnvironment.js";
import { APP_STORAGE } from "../../_CORE/_RuntimeConfig/_Config/Acomodar/AppConfig.Storage.js";

export const AUTH_PERSIST_SESSION = APP_ENVIRONMENT.AUTH.PERSIST_SESSION;

export const STORAGE_SESSION_HELPER = {
    GET_STORAGE: (key) => sessionStorage.getItem(key) || localStorage.getItem(key),

    SET_STORAGE: (key, value) => {
        localStorage.setItem(key, value);
    },

    GET_AUTH_STORAGE: (key) => {
        if (AUTH_PERSIST_SESSION) {
            const PERSISTED = localStorage.getItem(key);
            if (PERSISTED) return PERSISTED;

            const LEGACY_SESSION = sessionStorage.getItem(key);
            if (!LEGACY_SESSION) return null;

            localStorage.setItem(key, LEGACY_SESSION);
            sessionStorage.removeItem(key);
            return LEGACY_SESSION;
        }

        const SESSION = sessionStorage.getItem(key);
        if (SESSION) return SESSION;

        const LEGACY_PERSISTED = localStorage.getItem(key);
        if (!LEGACY_PERSISTED) return null;

        sessionStorage.setItem(key, LEGACY_PERSISTED);
        localStorage.removeItem(key);
        return LEGACY_PERSISTED;
    },

    SET_AUTH_STORAGE: (key, value) => {
        if (AUTH_PERSIST_SESSION) {
            sessionStorage.removeItem(key);
            localStorage.setItem(key, value);
            return;
        }

        localStorage.removeItem(key);
        sessionStorage.setItem(key, value);
    },

    SET_SESSION_STORAGE: (key, value) => {
        sessionStorage.setItem(key, value);
    },

    REMOVE_STORAGE: (key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    },

    CLEAR_AUTH: () => {
        [
            APP_STORAGE.TOKEN_USER_AUTH,
            APP_STORAGE.TOKEN_USER_REFRESH,
            APP_STORAGE.AUTH_VERIFY_EMAIL,
            APP_STORAGE.TEMP_EMAIL_VERIFY,
        ].filter(Boolean).forEach((key) => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    },
};
